/*
* MacroSquare order limit alert
*
* MacroSquare flavors are capped at 1 tray each per order. Whenever the cart is
* changed anywhere on the site, the quantity of each MacroSquare flavor is
* checked and a popup is shown if any flavor is over the cap.
*
* While the cart is over the cap, checkout is blocked: the Rebuy Smart Cart
* checkout button (and the theme's own checkout buttons) are marked disabled
* and any click on them re-opens the popup instead of going to checkout.
*/

(function () {
  var LIMIT_PER_FLAVOR = 1;
  var PRODUCT_MATCH = 'macrosquare';
  var MESSAGE =
    'MacroSquares are limited to one tray per flavor. Please remove any duplicate trays from your cart before checking out.';

  // Rebuy Smart Cart checkout button, plus the theme's cart drawer / cart page
  // checkout buttons in case a customer reaches them instead.
  var CHECKOUT_BUTTON_SELECTOR = '.rebuy-cart__checkout-button, .cart__checkout, [name="checkout"]';
  var BLOCKED_ATTR = 'data-ms-limit-blocked';

  var modal = null;
  var lastFocusedElement = null;
  var checkTimer = null;
  var overLimit = false;

  // "MacroSquare", "Macro Square" and "macro-square" should all match.
  function isMacroSquare(item) {
    var title = (item.product_title || item.title || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    return title.indexOf(PRODUCT_MATCH) !== -1;
  }

  // A single flavor can occupy more than one line item (a one-time purchase and
  // a subscription, for example), so quantities are totalled per product before
  // being compared to the cap.
  function isOverLimit(cart) {
    var items = (cart && cart.items) || [];
    var quantityByFlavor = {};

    return items.some(function (item) {
      if (!isMacroSquare(item)) return false;

      var flavor = item.product_id || item.product_title || item.title;
      quantityByFlavor[flavor] = (quantityByFlavor[flavor] || 0) + item.quantity;

      return quantityByFlavor[flavor] > LIMIT_PER_FLAVOR;
    });
  }

  function buildModal() {
    var el = document.createElement('div');
    el.className = 'ms-limit-modal';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', 'ms-limit-modal-message');
    el.hidden = true;
    el.innerHTML =
      '<div class="ms-limit-modal__overlay" data-ms-limit-close></div>' +
      '<div class="ms-limit-modal__content">' +
      '<button type="button" class="ms-limit-modal__close" aria-label="Close" data-ms-limit-close>' +
      '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
      '<path d="M1 1L15 15M15 1L1 15" stroke="currentColor" stroke-width="1.5" fill="none"/>' +
      '</svg></button>' +
      '<h3 class="ms-limit-modal__message" id="ms-limit-modal-message"></h3>' +
      '</div>';
    el.querySelector('.ms-limit-modal__message').textContent = MESSAGE;
    el.addEventListener('click', function (event) {
      if (event.target.closest('[data-ms-limit-close]')) {
        closeModal();
      }
    });
    document.body.appendChild(el);
    return el;
  }

  function onKeydown(event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
      closeModal();
    }
  }

  function openModal() {
    if (!modal) {
      modal = buildModal();
    }
    if (!modal.hidden) return;

    lastFocusedElement = document.activeElement;
    modal.hidden = false;
    document.addEventListener('keydown', onKeydown);
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true }));

    var closeButton = modal.querySelector('.ms-limit-modal__close');
    if (closeButton) closeButton.focus();
  }

  function closeModal() {
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    document.removeEventListener('keydown', onKeydown);
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
    lastFocusedElement = null;
  }

  // Mark (or unmark) every checkout button on the page. Rebuy re-renders its
  // cart with Vue, so this is re-run whenever new nodes are added to the page.
  function applyCheckoutBlock() {
    var buttons = document.querySelectorAll(CHECKOUT_BUTTON_SELECTOR);

    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i];
      var isBlocked = button.getAttribute(BLOCKED_ATTR) === 'true';

      if (overLimit && !isBlocked) {
        button.setAttribute(BLOCKED_ATTR, 'true');
        button.setAttribute('aria-disabled', 'true');
      } else if (!overLimit && isBlocked) {
        button.removeAttribute(BLOCKED_ATTR);
        button.removeAttribute('aria-disabled');
      }
    }
  }

  // Intercept the click in the capture phase so it is stopped before Rebuy's
  // own handler (or the theme's checkout form submit) ever runs. Keyboard
  // activation of a button also fires a click, so this covers Enter/Space too.
  function onCheckoutClick(event) {
    if (!overLimit) return;

    var button = event.target.closest(CHECKOUT_BUTTON_SELECTOR);
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openModal();
  }

  // Belt and braces: block the checkout form submit itself, in case something
  // submits it without a click on the button.
  function onCheckoutSubmit(event) {
    if (!overLimit) return;

    var form = event.target;
    if (!form || !form.querySelector || !form.querySelector(CHECKOUT_BUTTON_SELECTOR)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openModal();
  }

  function watchCheckoutButtons() {
    document.addEventListener('click', onCheckoutClick, true);
    document.addEventListener('submit', onCheckoutSubmit, true);

    if (!('MutationObserver' in window)) return;

    var observer = new MutationObserver(function () {
      if (overLimit) applyCheckoutBlock();
    });

    function startObserving() {
      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.body) {
      startObserving();
    } else {
      document.addEventListener('DOMContentLoaded', startObserving);
    }
  }

  function checkCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        overLimit = isOverLimit(cart);
        applyCheckoutBlock();

        if (overLimit) {
          openModal();
        } else {
          closeModal();
        }
      })
      .catch(function () {
        /* Never let a cart lookup failure break the page. */
      });
  }

  // Cart writes can fire several requests in a row (add then section render),
  // so coalesce them into a single check.
  function queueCheck() {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(checkCart, 50);
  }

  function isCartWriteUrl(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  // Watch every cart write the theme, apps or third parties make so the alert
  // appears the moment the cart goes over the limit.
  function watchCartRequests() {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function (input, init) {
        var url = typeof input === 'string' ? input : input && input.url;
        var request = nativeFetch.apply(this, arguments);
        if (isCartWriteUrl(url)) {
          request.then(queueCheck, queueCheck);
        }
        return request;
      };
    }

    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartWriteUrl(url)) {
        this.addEventListener('loadend', queueCheck);
      }
      return nativeOpen.apply(this, arguments);
    };
  }

  watchCartRequests();
  watchCheckoutButtons();

  [
    'theme:cart:added',
    'theme:cart:update',
    'theme:cart:loaded',
    'rebuy:smartcart.ready',
    'rebuy:smartcart.show',
    'rebuy:cart.change'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, queueCheck);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', queueCheck);
  } else {
    queueCheck();
  }

  // Re-check on back/forward navigation, where the page is restored from cache
  // but the cart may have changed in the meantime.
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) queueCheck();
  });
})();
